import React, { useState } from 'react';
import { tutorVoiceOptions, updateVoiceSelection } from '../data/tutorVoiceData';

const TutorVoicePage = ({ language = 'traditional', onBack, onSave }) => {
  const [selectedVoices, setSelectedVoices] = useState(
    tutorVoiceOptions.filter(voice => voice.isSelected).map(voice => voice.id)
  );

  const getText = (textObj) => {
    return textObj[language] || textObj.traditional;
  };

  const handleVoiceToggle = (voiceId) => {
    setSelectedVoices(prev => {
      const newSelection = prev.includes(voiceId)
        ? prev.filter(id => id !== voiceId)
        : [...prev, voiceId];
      
      // Update the data
      updateVoiceSelection(voiceId, !prev.includes(voiceId));
      
      return newSelection;
    });
  };

  const handlePlayVoice = (voiceId) => {
    // Voice preview functionality would be implemented here
    console.log('Playing voice preview for:', voiceId);
  };

  const handleSave = () => {
    onSave(selectedVoices);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900 text-white">
      {/* Header */}
      <div className="px-6 py-6">
        <div className="flex items-center justify-between mb-6">
          <button onClick={onBack} className="text-white">
            ←
          </button>
          <h1 className="text-xl font-bold">
            {language === 'traditional' ? '更換導師語音' :
             language === 'simplified' ? '更换导师语音' :
             'Change Tutor Voice'}
          </h1>
          <div className="w-8"></div> {/* Spacer for centering */}
        </div>

        {/* Voice Options List */}
        <div className="space-y-3 mb-20">
          {tutorVoiceOptions.map((voice) => (
            <div
              key={voice.id}
              className="bg-gray-800/30 border border-gray-600 rounded-xl p-4"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4 flex-1">
                  {/* Country Code */}
                  <div className="w-12 h-8 bg-gray-700 rounded flex items-center justify-center text-white font-bold text-sm">
                    {voice.countryCode}
                  </div>
                  
                  {/* Voice Info */}
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-white mb-1">
                      {getText(voice.accentName)}
                    </h3>
                    <p className="text-gray-400 text-sm">
                      {getText(voice.description)}
                    </p>
                  </div>
                </div>
                
                {/* Controls */}
                <div className="flex items-center space-x-3">
                  {/* Selection Indicator */}
                  <button
                    onClick={() => handleVoiceToggle(voice.id)}
                    className={`w-6 h-6 rounded-full border-2 transition-colors ${
                      selectedVoices.includes(voice.id)
                        ? voice.selectionColor === 'pink'
                          ? 'bg-pink-500 border-pink-500'
                          : 'bg-blue-500 border-blue-500'
                        : 'bg-transparent border-gray-400'
                    }`}
                  />
                  
                  {/* Play Button */}
                  <button
                    onClick={() => handlePlayVoice(voice.id)}
                    className="w-8 h-8 bg-white rounded-full flex items-center justify-center"
                  >
                    <div className="w-0 h-0 border-l-4 border-l-gray-800 border-t-2 border-t-transparent border-b-2 border-b-transparent ml-1"></div>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Save Button */}
      <div className="fixed bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-gray-900 to-transparent">
        <button
          onClick={handleSave}
          className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-4 rounded-xl transition-colors"
        >
          {language === 'traditional' ? '儲存' :
           language === 'simplified' ? '保存' :
           'Save'}
        </button>
      </div>
    </div>
  );
};

export default TutorVoicePage;
